import React from 'react';
import Flexbox from 'flexbox-react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import ProcessField from 'components/core/fields/ProcessField';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import InfoMessages from 'components/core/help/InfoMessages';
import Constants from 'utils/Constants';
import ProcessUtils from 'utils/ProcessUtils';

export default class OutputVariableMappingField extends ProcessField {
    static propTypes = Object.assign({
        retrievedVariableName: PropTypes.string,
        labelWidth: PropTypes.string,
        minWidth: PropTypes.string
    }, ProcessField.propTypes);

    getOutputDatastreams = () => {
        return ProcessUtils.getRetrievedVariableOutputDatastreams(this.props.process, this.props.retrievedVariableName);
    };

    getOutputVariableName = (outputDatastreamName) => {
        return this.props.process.variable_retrieval.output_datastream_variable_mappings[outputDatastreamName][this.props.retrievedVariableName];
    };

    getOutputstreamVariableOptions = () => {
        const outputDatastreamName = this.getOutputDatastreams();

        let outputstreamVariables = [];
        if (ProcessUtils.getDatastreamVariablesForDod(outputDatastreamName)) {
            outputstreamVariables = Object.keys(ProcessUtils.getDatastreamVariablesForDod(outputDatastreamName));
        }

        const options = Constants.convertArrayToSelectOptions(outputstreamVariables);
        Constants.sortSelectOptions(options);
        return options;
    };

    getFieldPath = (outputDatastreamName) => {
        return ['variable_retrieval', 'output_datastream_variable_mappings', outputDatastreamName, this.props.retrievedVariableName];
    };

    renderSingleOutputstream = () => {
        const outputDatastreamName = this.getOutputDatastreams()[0];
        const outputVariableName = this.getOutputVariableName(outputDatastreamName);
        const value = Constants.convertValueToSelectValue(outputVariableName);
        return (
            <RIEComboBox
                value={value}
                options={this.getOutputstreamVariableOptions()}
                multi={false}
                change={this.onFieldUpdated}
                fieldPath={this.getFieldPath(outputDatastreamName)}
                clearable
                creatable
                isDisabled={!this.props.hasWritePermissions}
                processId={this.props.process.name}
                processErrors={this.props.processErrors}
                minWidth="250px"
            />
        );
    };

    renderMultipleOutputstreams = () => {
        const outputList = [];
        this.getOutputDatastreams().forEach(outputDatastreamName => {
            const outputVariableName = this.getOutputVariableName(outputDatastreamName);
            const value = Constants.convertValueToSelectValue(outputVariableName);
            outputList.push(
                <tr key={outputDatastreamName}>
                    <td className={css`padding-right:10px;`}>
                        {outputDatastreamName}
                    </td>
                    <td>
                        <RIEComboBox
                            value={value}
                            options={this.getOutputstreamVariableOptions()}
                            multi={false}
                            change={this.onFieldUpdated}
                            fieldPath={this.getFieldPath(outputDatastreamName)}
                            clearable
                            creatable
                            isDisabled={!this.props.hasWritePermissions}
                            processId={this.props.process.name}
                            processErrors={this.props.processErrors}
                            minWidth="250px"
                        />
                    </td>
                </tr>
            );
        });

        return (
            <table className="table table-bordered">
                <tbody>
                    {outputList}
                </tbody>
            </table>
        );
    };

    render() {
        const outputDatastreamName = this.getOutputDatastreams();

        return (
            <Flexbox className={this.props.className} flexDirection="row" alignItems="flex-start" flexGrow={1}>
                {this.props.displayLabel &&
                <InfoBoxLabel
                    label="Output Datastream Variable"
                    width={this.props.labelWidth}
                    labelWrap
                    message={InfoMessages.outputMapping}
                />
                }
                <Flexbox flexGrow={1}>
                    {outputDatastreamName.length === 1 ?
                        this.renderSingleOutputstream()
                        :
                        this.renderMultipleOutputstreams()
                    }
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/OutputVariableMappingField.js